import styled from 'styled-components';

import { Color, ZIndex } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { hexToRgba } from '../../../utils';

import { OverlayProps } from './overlay.types';

export const Overlay: StyledComponent<'div', OverlayProps> = styled.div<OverlayProps>`
  background-color: ${hexToRgba(Color.Black, 0)};
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  pointer-events: none;
  z-index: ${ZIndex.Overlay};
  transition: 0.3s;

  ${({ $isVisible }: OverlayProps): string | false => $isVisible && `
    pointer-events: initial;
    background-color: ${hexToRgba(Color.Black, 0.5)};
  `};
`;
